import React from 'react'
import './Firms.css';
import { ButtonSecoundry, SectionHeader, SectionWrap } from '../../Components';
import FieldsShort from '../FieldsShort/FieldsShort';
import { useTranslation } from 'react-i18next';


function Firms() {
  const { t, i18n } = useTranslation();
  
  return (
    <>
    <div className='fieldsPageContainer'>
        <div className='headPage firms'>
        </div>
        <div className='containerNew'>
          <SectionWrap>
            <SectionHeader title={t('fieldsPageTitle1')} disc={t('fieldsPageSpan')} />
            <div className='fieldInfo'>
                <p>{t('fieldsPage1p1')}</p>
                <span>{t('fieldsPage1Span1')}</span>
                <p>{t('fieldsPage1p2')}</p>
                <span>{t('fieldsPage1Span2')}</span>
                <p>{t('fieldsPage1p3')}</p>
                <p>{t('fieldsPage1p4')}</p>
            </div>
            <ButtonSecoundry className='askBtnFields' href='/askConsults'>{t('askYourConsult')}</ButtonSecoundry>
        </SectionWrap>
        </div>
        <FieldsShort />
    </div>
    </>
  )
}

export default Firms